import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import ChatInterface from './pages/ChatInterface';
import Login from './pages/Login';
import LogoManagement from './pages/LogoManagement';
import DocumentUpload from './pages/DocumentUpload';
import WidgetIntegration from './pages/WidgetIntegration';
import InstructionsManagement from './pages/InstructionsManagement';
import ApiToolsManagement from './pages/ApiToolsManagement';
import ChatSettings from './pages/ChatSettings';

function App() {
  const [activeTab, setActiveTab] = useState('logo');
  const [user, setUser] = useState(() => {
    const saved = sessionStorage.getItem('user');
    return saved ? JSON.parse(saved) : null;
  });

  const handleLogin = () => {
    const userData = { authenticated: true };
    setUser(userData);
    sessionStorage.setItem('user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    sessionStorage.removeItem('user');
  };

  const AdminPanelWrapper = () => {
    const navigate = useNavigate();
    
    const handleAdminPanel = () => {
      navigate('/admin');
    };
    
    return <ChatInterface fullscreen={true} onLogout={handleLogout} onAdminPanel={handleAdminPanel} />;
  };

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login onLogin={handleLogin} />} />
        {!user ? (
          <Route path="/*" element={<Navigate to="/login" replace />} />
        ) : (
          <>
            <Route path="/" element={<Navigate to="/chat" replace />} />
            <Route path="/chat" element={<AdminPanelWrapper />} />
            <Route path="/admin" element={
              <div style={{ display: 'flex' }}>
                <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
                <div className="main-content">
                  <div style={{ padding: '20px' }}>
                    <h1>Admin Dashboard</h1>
                    <p>Select an option from the sidebar to manage your chatbot.</p>
                  </div>
                </div>
              </div>
            } />
            <Route path="/logo" element={
              <div style={{ display: 'flex' }}>
                <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
                <div className="main-content"><LogoManagement /></div>
              </div>
            } />
            <Route path="/documents" element={
              <div style={{ display: 'flex' }}>
                <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
                <div className="main-content"><DocumentUpload /></div>
              </div>
            } />
            <Route path="/widget" element={
              <div style={{ display: 'flex' }}>
                <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
                <div className="main-content"><WidgetIntegration /></div>
              </div>
            } />
            <Route path="/instructions" element={
              <div style={{ display: 'flex' }}>
                <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
                <div className="main-content"><InstructionsManagement /></div>
              </div>
            } />
            <Route path="/api-tools" element={
              <div style={{ display: 'flex' }}>
                <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
                <div className="main-content"><ApiToolsManagement /></div>
              </div>
            } />
            <Route path="/chat-settings" element={
              <div style={{ display: 'flex' }}>
                <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
                <div className="main-content"><ChatSettings /></div>
              </div>
            } />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;